import React from "react";
import styles from "./Board.module.css";

export const Board: React.SFC = ({ children }) => (
  <div className={styles.board}>{children}</div>
);
